import React, {useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useI18n } from '../../../../i18n';
import PresenceDetectorListItem from './PresenceDetectorListItem';
import List from '../../general/list/List';
import Input from '../../general/form/Input';
import { actions as processorActions } from '../../../redux/api/processors';
import { className } from '../../../lib/className';
import { sortByName } from '../../../lib/sorting';
import './presenceDetectorList.scss';

const actions = processorActions.devicePresence;

/**
 * @param {Object} props
 * @param {number} props.selectedId
 * @param {function} props.onSelect
 * @param {function} props.onIntent
 */

function PresenceDetectorList(props) {
	const { f } = useI18n();
	const [filter, setFilter] = useState('');
	const detectors = props.detectors.list;
	let content = null;

	useEffect(() => {
		if (detectors == null) {
			props.dispatch(actions.load.request());
		}
	}, []);

	const getPresenceDetectors = () => {
		return filter
			? detectors.filter(presenceDetector => presenceDetector.name.toLowerCase().includes(filter.toLowerCase()))
			: detectors
		;
	}

	if (detectors != null) {
		const items = sortByName(getPresenceDetectors()).map(detector =>
			<PresenceDetectorListItem
				className={className({ 'selected': (props.selectedId && props.selectedId == detector.processorId) })}
				key={detector.processorId}
				detector={detector}
				onSelect={props.onSelect}
				onIntent={props.onIntent}
			/>
		);
		content = (<List>{items}</List>);
	}

	return (<>
		<div className="filter">
			<Input label={f('filter')} value={filter} onChange={setFilter} cleanable />
		</div>
		<div className="presence-detector-list">
			<label>
				{f('presence detectors')}
			</label>
			{content}
		</div>
	</>);
}

export default connect(
	state => ({
		detectors: state.processors.devicePresence
	})
)(withRouter(PresenceDetectorList));
